import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { SparkAdBudgetMode } from '@/app/common/general-types/tiktok-spark-ads.dto';
import { CreateSparkCampaign } from '../../service/create-spark-campaign/create-spark-campaign';
import { ManageBriefTabsService } from '../../../../service/manage-brief-tabs/manage-brief-tabs.service';

@Component({
  selector: 'bttv2-advertising-settings',
  imports: [],
  templateUrl: './advertising-settings.html',
  styleUrl: './advertising-settings.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdvertisingSettings implements OnInit {

  readonly budgetModes: ReadonlyArray<{ value: SparkAdBudgetMode; label: string }> = [
    { value: 'BUDGET_MODE_DAY', label: 'Daily' },
    { value: 'BUDGET_MODE_TOTAL', label: 'Lifetime' },
    { value: 'BUDGET_MODE_INFINITE', label: 'Unlimited' },
  ];

  /** Services */
  public createSparkCampaignService = inject(CreateSparkCampaign);
  private manageBriefTabsService = inject(ManageBriefTabsService);
  private currentUserService = inject(CurrentUserService);
  /** Services - END */

  /** ISO 4217 code for the focussed business account (wallet / billing). */
  businessCurrencyCode(): string {
    const code = this.currentUserService.focussedBrand?.currencyCode;
    return typeof code === 'string' && code.trim().length > 0 ? code.trim().toUpperCase() : 'USD';
  }

  ngOnInit(): void {
    const title = this.manageBriefTabsService.focussedBrief()?.title;
    if (title) {
      this.createSparkCampaignService.campaignName.set(title);
    }
  }

  onCampaignNameInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.createSparkCampaignService.campaignName.set(value === '' ? undefined : value);
  }

  onBudgetOptimizeChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.createSparkCampaignService.budgetOptimizeOn.set(checked);
  }

  onBudgetModeSelected(mode: SparkAdBudgetMode): void {
    this.createSparkCampaignService.selectedBudgetMode.set(mode);
  }

  isBudgetModeSelected(mode: SparkAdBudgetMode): boolean {
    return this.createSparkCampaignService.selectedBudgetMode() === mode;
  }

  budgetModeLabel(mode: SparkAdBudgetMode | undefined): string {
    if (!mode) {
      return '';
    }
    const row = this.budgetModes.find((m) => m.value === mode);
    return row?.label ?? mode;
  }

  onBudgetInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.createSparkCampaignService.budget.set(value === '' ? 0 : parseFloat(value));
  }
}
